<template>
  <div>
    <a :href="wpLink" target="_blank">
      <img v-if="!arabic" src="../../assets/images/LogoLight.svg" alt="Ayadi" />
      <img v-else src="../../assets/images/LogoLightArabic.svg" alt="Ayadi" width="150px" />
    </a>
  </div>
</template>

<script>
import storageClient from "@/services/storageClient";

export default {
  name: "LogoLight",
  computed: {
    arabic() {
      return storageClient.getLanguage() === "ar";
    },
    wpLink() {
      let link = "https://ayadihealth.co/";
      if (this.arabic) {
        link = "https://ayadihealth.co/ar/";
      }
      return link;
    }
  }
};
</script>

<style lang="scss" scoped></style>
